import { render, staticRenderFns } from "./deregistration.vue?vue&type=template&id=3bff17e4&scoped=true"
import script from "./deregistration.vue?vue&type=script&lang=js"
export * from "./deregistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff17e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bff17e4')) {
      api.createRecord('3bff17e4', component.options)
    } else {
      api.reload('3bff17e4', component.options)
    }
    module.hot.accept("./deregistration.vue?vue&type=template&id=3bff17e4&scoped=true", function () {
      api.rerender('3bff17e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/signLimitConfiguration/component/deregistration.vue"
export default component.exports